import { ServiceBase } from "../ServiceBase";
import { IDailyDealService } from "./daily-deal.service.interface";
import { action, observable, makeObservable } from "mobx";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";

export class DailyDealService extends ServiceBase implements IDailyDealService {
    @observable.ref
    public dailyDealCampaignId: string | null = null;

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        makeObservable(this);

        this.reaction(
            () => this.services.user.isAuthorized,
            async (isAuthorized) => {
                await this._fetchDailyDealCampaign(isAuthorized)
            },
            {
                fireImmediately: true
            }
        );

        this.reaction(
            () => { return {
                dailyDealCampaignId: this.dailyDealCampaignId,
                currentRoute: this.services.routing.currentRoute
            }},
            (data) => {
                if (data.dailyDealCampaignId && data.currentRoute.isOrbitRoute && data.currentRoute.data?.arenaType) {
                    this.services.analytics.sendAnalytics('Daily_Deal', 'View', data.currentRoute.data.arenaType);
                }
            },
            { fireImmediately: true }
        );
    }

    @action.bound
    private setDailyDealCampaignId(val: string | null) {
        this.dailyDealCampaignId = val;
    }

    private async _fetchDailyDealCampaign(isAuthorized: boolean) {
        /**
         * If the user is not logged in, don't fetch real data;
         * More, if any data was set, reset to null
         */
        if (!isAuthorized) {
            this.setDailyDealCampaignId(null);
            return;
        }
        /**
         * If data exists reuse it
         */
        if (this.dailyDealCampaignId) {
            return;
        }

        try {
            let dailyDeals = await this.services.sdk.getDailyDealCampaigns();
            if (dailyDeals.length === 0) {
                this.setDailyDealCampaignId(null);
            } else {
                this.setDailyDealCampaignId(dailyDeals[0].MarketingCampaignId);
            }
        } catch (e) {
            this.services.logger.error("getDailyDealCampaigns failed", e);
            this.setDailyDealCampaignId(null);
        }
    }

    removeDailyDealIndicator = () => {
        this.setDailyDealCampaignId(null);
    }

    visitDailyDeal() {
        if (!this.dailyDealCampaignId) {
            return;
        }
        this.services.externalLinks.openRichPage({
            campaignId: this.dailyDealCampaignId
        });

    }
}
